import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SvgIcon from '@mui/material/SvgIcon';
import MailOutlineIcon from '@mui/icons-material/MailOutlineOutlined';
import LockClockOutlinedIcon from '@mui/icons-material/LockClockOutlined';
import { useTranslation } from 'react-i18next';

// Sales contact address (matches the login page "Contact us" address).
const SALES_EMAIL = 'contact-user-guest@mirukuru.co.jp';

export default function AccessExpiredDialog({ open, plan, onClose }) {
  const { t } = useTranslation();

  const message =
    plan === 'trial' ? t('AccessEndedMessageTrial') : t('AccessEndedMessage');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
    >
      <Box sx={{ p: 3 }}>
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <SvgIcon color="error" fontSize="large">
              <LockClockOutlinedIcon />
            </SvgIcon>
            <Typography variant="h4" component="div">
              {t('AccessEndedTitle')}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <Typography color="text.secondary" variant="body1">
              {message}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{t('BackToLogin')}</Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<MailOutlineIcon />}
            href={`mailto:${SALES_EMAIL}`}
          >
            {t('ContactSales')}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
